import { TenderingProcess } from '../commonaggregatecomponents/TenderingProcess';
import { PublishAwardIndicator } from '../commonbasiccomponents/PublishAwardIndicator';
import { IssueTime } from '../commonbasiccomponents/IssueTime';
import { CopyIndicator } from '../commonbasiccomponents/CopyIndicator';
import { Language } from '../commonaggregatecomponents/Language';
import { VersionID } from '../commonbasiccomponents/VersionID';
import { Signature } from '../commonaggregatecomponents/Signature';
import { ProcurementProject } from '../commonaggregatecomponents/ProcurementProject';
import { ProcurementProjectLot } from '../commonaggregatecomponents/ProcurementProjectLot';
import { TenderingTerms } from '../commonaggregatecomponents/TenderingTerms';
import { UBLVersionID } from '../commonbasiccomponents/UBLVersionID';
import { UBLExtensions } from '../commonextensioncomponents/UBLExtensions';
import { ContractFolderID } from '../commonbasiccomponents/ContractFolderID';
import { IssueDate } from '../commonbasiccomponents/IssueDate';
import { ProfileExecutionID } from '../commonbasiccomponents/ProfileExecutionID';
import { NoticeTypeCode } from '../commonbasiccomponents/NoticeTypeCode';
import { Party } from '../commonaggregatecomponents/Party';
import { NoticeLanguageCode } from '../commonbasiccomponents/NoticeLanguageCode';
import { Note } from '../commonbasiccomponents/Note';
import { CustomizationID } from '../commonbasiccomponents/CustomizationID';
import { ProfileID } from '../commonbasiccomponents/ProfileID';
import { ContractingParty } from '../commonaggregatecomponents/ContractingParty';
import { ID } from '../commonbasiccomponents/ID';
import { RegulatoryDomain } from '../commonbasiccomponents/RegulatoryDomain';
import { CustomerParty } from '../commonaggregatecomponents/CustomerParty';
import { UUID } from '../commonbasiccomponents/UUID';
import { DocumentReference } from '../commonaggregatecomponents/DocumentReference';
import { RequestedPublicationDate } from '../commonbasiccomponents/RequestedPublicationDate';
import { TenderResult } from '../commonaggregatecomponents/TenderResult';
import { PreviousVersionID } from '../commonbasiccomponents/PreviousVersionID';

export class ContractAwardNotice  {

	note: Array<Note>;
	tenderResult: Array<TenderResult>;
	issueTime: IssueTime;
	requestedPublicationDate: RequestedPublicationDate;
	signature: Array<Signature>;
	uuid: UUID;
	profileExecutionID: ProfileExecutionID;
	previousVersionID: PreviousVersionID;
	versionID: VersionID;
	minutesDocumentReference: Array<DocumentReference>;
	profileID: ProfileID;
	originatorCustomerParty: CustomerParty;
	id: ID;
	issueDate: IssueDate;
	regulatoryDomain: Array<RegulatoryDomain>;
	previousDocumentReference: Array<DocumentReference>;
	receiverParty: Party;
	customizationID: CustomizationID;
	copyIndicator: CopyIndicator;
	procurementProjectLot: Array<ProcurementProjectLot>;
	ublExtensions: UBLExtensions;
	noticeLanguageCode: NoticeLanguageCode;
	additionalNoticeLanguage: Array<Language>;
	noticeTypeCode: NoticeTypeCode;
	publishAwardIndicator: PublishAwardIndicator;
	contractingParty: Array<ContractingParty>;
	tenderingTerms: TenderingTerms;
	ublVersionID: UBLVersionID;
	tenderingProcess: TenderingProcess;
	procurementProject: ProcurementProject;
	contractFolderID: ContractFolderID;
}
